import {TileState} from "../model";
import {CrudRepository} from ".";
import Keycloak from "keycloak-js";

export class TileStateRepository extends CrudRepository<TileState> {
    constructor(keycloak: Keycloak | null = null) {
        super('tile_states', "PATCH", keycloak)
        this.contentTypes["UPDATE"] = "application/merge-patch+json"
    }

    protected jsonToEntity(json: any): TileState | null {
        if (!json) return null;
        return {
            id: json.id,
            createdAt: json.createdAt,
            updatedAt: json.updatedAt,
            deletedAt: json.deletedAt,
            name: json.name,
            color: json.color,
            description: json.description,
            disable: json.disable
        }
    }

    protected entityToJson(entity: TileState): any {
        return super.entityToJson(entity);
    }
}